import React, { FunctionComponent } from "react";
import { Plan } from "../../@types";
import {
  getBenefitCost,
  hasSomeDentalCoverage,
  useTranslate,
} from "../../helpers";

const ExtraBenefits: FunctionComponent<{
  plans: Plan[];
  selectedPlan: Plan | undefined;
}> = ({ plans, selectedPlan }) => {
  const t = useTranslate();

  const benefits = [
    {
      label: t("plan_terms.hearing_aids"),
      benefit: "hearing",
      service: "hearing_aids",
    },
    {
      label: t("plan_terms.preventive_dental"),
      benefit: "preventive_dental",
      service: "oral_exam",
    },
    {
      label: t("plan_terms.comprehensive_dental"),
      getValue: (plan: Plan) =>
        hasSomeDentalCoverage(t, plan)
          ? t("some_coverage")
          : t("plan_terms.not_covered"),
    },
    {
      label: t("plan_terms.vision.eyeglasses"),
      benefit: "vision",
      service: "eyeglasses_frames_and_lenses",
    },
    {
      label: t("plan_terms.wellness_programs"),
      benefit: "wellness_programs",
    },
    {
      label: t("plan_terms.transportation"),
      benefit: "transportation",
    },
    {
      label: t("plan_terms.skilled_nursing_facility"),
      benefit: "skilled_nursing_facility",
    },
    {
      label: t("plan_terms.medical_equipment.durable_medical_equipment"),
      benefit: "medical_equipment",
      service: "durable_medical_equipment",
    },
    {
      label: t("plan_terms.medical_equipment.diabetes_supplies"),
      benefit: "medical_equipment",
      service: "diabetes_supplies",
    },
  ];

  return (
    <>
      <tr>
        <td
          className="PlanComparePage__tableHeader"
          colSpan={selectedPlan ? 1 : plans.length + 1}
        >
          {t("plan_terms.extra_benefits")}
        </td>
      </tr>
      {benefits.map((b, index) => {
        const { label, service, benefit, getValue } = b;
        const lastRow = index === benefits.length - 1;

        return (
          <tr key={index}>
            <td
              className={`PlanComparePage__tableLabelColumn ${
                lastRow ? "PlanComparePage__lastRowCell" : ""
              }`}
            >
              {label}
            </td>

            {plans.map((plan, index) => {
              let value = "";

              if (getValue) {
                value = getValue(plan);
              } else if (benefit) {
                value = getBenefitCost(t, { plan, benefit, service });
              }
              return (
                <td
                  key={index}
                  className={`${
                    selectedPlan?.id === plan.id
                      ? "PlanComparePage__selectedCell"
                      : ""
                  } ${lastRow ? "PlanComparePage__lastRowCell" : ""}`}
                >
                  <span className="ds-text-heading--md  ds-u-display--block ds-u-lg-display--none mct-hide-print">
                    {label}
                  </span>
                  {value}
                </td>
              );
            })}
          </tr>
        );
      })}
    </>
  );
};

export default ExtraBenefits;
